import React from "react";

import MaterialTable from "@material-table/core";
import _ from "lodash";

import {COLUMNS, LOCALIZATION, OPTIONS} from "./Params/LogFrontendErrorParams";
import {tableIcons} from "../../ui-components/TableIcons";
import TableStyle from "../../ui-components/TableStyle";


function LogFrontendErrorTable({data}) {

  return (
    <TableStyle>
      <MaterialTable
        icons={tableIcons}
        columns={COLUMNS}
        data={data.map((value, index) => ({...value, id: index}))}
        options={OPTIONS}
        title={"Frontend"}
        localization={LOCALIZATION}
      />
    </TableStyle>
  )
}

export default React.memo(LogFrontendErrorTable, (props, nextProps) => {
  // Render component only when users change
  return _.isEqual(props.data, nextProps.data);
});
